import { render, staticRenderFns } from "./Postbox.vue?vue&type=template&id=39267372&scoped=true&"
var script = {}
import style0 from "./Postbox.vue?vue&type=style&index=0&id=39267372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39267372",
  null
  
)

export default component.exports